export const MenuLinks = [
    {
        title: "Accueil", 
        src: "/",
    },
    {
        title: "Projets",
        src: '/projects'
    }/*,
    {
        title: "Galerie",
        src: '/Gallery'
    } */
]